import EmptyWrap from "@/components/Gui/EmptyWrap";

export default [
    {
        path: 'subscription-tariff',
        component: EmptyWrap,
        children: [
            {
                path: '',
                name: 'subscription-tariff.list',
                component: require('@/views/SubscriptionTariff/SubscriptionTariffList').default,
            },
            {
                path: 'create',
                name: 'subscription-tariff.create',
                component: require('@/views/SubscriptionTariff/SubscriptionTariffForm').default,
            },
            {
                path: ':id',
                component: require('@/views/SubscriptionTariff/Card/WrapBlock').default,
                children: [
                    {
                        path: 'detail',
                        name: 'subscription-tariff.detail',
                        component: require('@/views/SubscriptionTariff/Card/SubscriptionTariffDetail').default,
                    },
                ]
            },
            {
                path: ':id/edit',
                name: 'subscription-tariff.edit',
                component: require('@/views/SubscriptionTariff/SubscriptionTariffForm').default,
            },
        ]
    },
]